import React from 'react';
import logo from '../../assets/logo1-removebg-preview.png';

const Terms: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    {/* Header avec logo */}
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <img 
          src={logo} 
          alt="Genius Vente Logo" 
          className="h-12 w-auto"
        />
      </div>
    </div>
    
    {/* Contenu */}
    <div className="max-w-2xl mx-auto p-6 text-gray-800 bg-white my-8 rounded-lg shadow-sm">
      <h1 className="text-2xl font-bold mb-4">Conditions d'utilisation – Genius Vente</h1>
      <p className="mb-4">En utilisant l'application <strong>Genius Vente</strong>, vous acceptez les conditions d'utilisation suivantes.<br/>
      Ces conditions régissent votre utilisation de notre service et constituent un accord entre vous et <strong>Genius Vente</strong>.</p>
      
      <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-6">
        <h2 className="text-xl font-bold text-green-800 mb-2">📜 CONTRAT DE LICENCE D'UTILISATEUR – GENIUS VENTE</h2>
        <p className="text-green-700 mb-2"><strong>Dernière mise à jour : 20 juillet 2025</strong></p>
        <p className="text-green-700">Les applications Genius Vente mises à disposition sur l'App Store vous sont <strong>concédées sous licence, et non vendues</strong>. Votre utilisation de l'application est soumise à votre acceptation du présent <strong>Contrat de Licence Utilisateur Final (« CLUF »)</strong> conclu entre vous (l'Utilisateur) et le Fournisseur de l'Application (Genius Vente).</p>
      </div>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptation des conditions</h2>
      <p className="mb-4">En téléchargeant, installant ou utilisant l'application Genius Vente, vous confirmez que vous avez lu, compris et accepté ces conditions d'utilisation.<br/>
      Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser l'application.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">2. Description du service</h2>
      <p className="mb-4">Genius Vente est une application mobile conçue pour aider les commerçants à gérer leurs ventes, leurs produits et leurs clients.<br/>
      L'application propose les fonctionnalités suivantes :</p>
      <ul className="list-disc list-inside mb-4">
        <li>Gestion des ventes et des transactions</li>
        <li>Suivi des produits et du stock</li>
        <li>Gestion de la clientèle</li>
        <li>Génération de rapports et statistiques</li>
        <li>Fonctionnalités de sauvegarde et synchronisation</li>
      </ul>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">3. Utilisation autorisée</h2>
      <p className="mb-4">Vous vous engagez à utiliser l'application uniquement à des fins légales et conformes à ces conditions.<br/>
      Vous vous engagez à ne pas :</p>
      <ul className="list-disc list-inside mb-4">
        <li>Utiliser l'application pour des activités illégales</li>
        <li>Tenter d'accéder non autorisé aux systèmes ou données</li>
        <li>Porter atteinte à la sécurité ou à l'intégrité de l'application</li>
        <li>Partager votre compte avec des tiers non autorisés</li>
        <li>Utiliser l'application pour harceler ou nuire à autrui</li>
      </ul>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">4. Compte utilisateur</h2>
      <p className="mb-4">Pour utiliser certaines fonctionnalités de l'application, vous devez créer un compte.<br/>
      Vous êtes responsable de :</p>
      <ul className="list-disc list-inside mb-4">
        <li>Maintenir la confidentialité de vos identifiants</li>
        <li>Toutes les activités effectuées sous votre compte</li>
        <li>Nous informer immédiatement de toute utilisation non autorisée</li>
        <li>Fournir des informations exactes et à jour</li>
      </ul>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">5. Propriété intellectuelle</h2>
      <p className="mb-4">L'application Genius Vente et son contenu sont protégés par les droits de propriété intellectuelle.<br/>
      Vous conservez la propriété de vos données, mais accordez à Genius Vente une licence limitée pour les traiter conformément à notre politique de confidentialité.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">6. Limitation de responsabilité</h2>
      <p className="mb-4">Genius Vente s'efforce de fournir un service fiable, mais ne peut garantir une disponibilité continue ou sans erreur.<br/>
      Nous ne sommes pas responsables des pertes de données, des interruptions de service ou des dommages indirects.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">7. Modifications des conditions</h2>
      <p className="mb-4">Nous nous réservons le droit de modifier ces conditions à tout moment.<br/>
      Les modifications seront notifiées via l'application ou par email. Votre utilisation continue de l'application après les modifications constitue votre acceptation des nouvelles conditions.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">8. Résiliation</h2>
      <p className="mb-4">Vous pouvez résilier votre compte à tout moment en nous contactant.<br/>
      Nous pouvons également suspendre ou résilier votre accès en cas de violation de ces conditions.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">9. Contact</h2>
      <p className="mb-4">Pour toute question concernant ces conditions d'utilisation, contactez-nous via l'application ou par email.</p>
      
      <hr className="my-4" />
      
      <h2 className="text-xl font-semibold mt-6 mb-2">CONTRAT DE LICENCE D'UTILISATEUR - DÉTAILS</h2>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">a. Portée de la licence</h3>
      <p className="mb-4">Le Fournisseur vous accorde une <strong>licence personnelle, non transférable et non exclusive</strong>, vous permettant d'installer et d'utiliser l'application Genius Vente sur tout appareil Apple que vous possédez ou contrôlez, conformément aux Règles d'utilisation de l'App Store.</p>
      <p className="mb-4">Vous vous engagez à ne pas :</p>
      <ul className="list-disc list-inside mb-4">
        <li>distribuer ou rendre disponible l'application sur un réseau ;</li>
        <li>transférer, revendre ou sous-licencier l'application ;</li>
        <li>faire de l'ingénierie inverse, désassembler ou tenter de dériver le code source ;</li>
        <li>copier, modifier ou créer une œuvre dérivée de l'application (sauf dans les cas permis par la loi ou par la licence open-source applicable).</li>
      </ul>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">b. Consentement à l'utilisation des données</h3>
      <p className="mb-4">Vous acceptez que Genius Vente puisse collecter des <strong>données techniques non personnelles</strong> (type d'appareil, système d'exploitation, logs d'erreurs…) afin de fournir des mises à jour, améliorer ses services, et assurer le bon fonctionnement de l'application.</p>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">c. Abonnements à renouvellement automatique</h3>
      <p className="mb-4">Certaines fonctionnalités avancées de l'application nécessitent un abonnement :</p>
      <ul className="list-disc list-inside mb-4">
        <li>Les abonnements sont à renouvellement automatique, sauf résiliation au moins 24 heures avant la fin de la période en cours.</li>
        <li>Le paiement sera débité via votre compte Apple lors de la confirmation de l'achat.</li>
        <li>Vous pouvez gérer ou annuler vos abonnements via les <strong>Réglages de votre compte Apple</strong>.</li>
      </ul>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">d. Services externes</h3>
      <p className="mb-4">L'application Genius Vente peut inclure des <strong>liens vers des services tiers</strong> (paiement mobile, API de géolocalisation, services de messagerie…). Vous utilisez ces services à vos propres risques. Genius Vente ne peut être tenu responsable des contenus ou de la sécurité de ces services externes.</p>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">e. Résiliation</h3>
      <p className="mb-4">Le présent contrat peut être résilié à tout moment par vous ou par Genius Vente. En cas de non-respect des conditions d'utilisation, votre accès à l'application pourra être suspendu ou annulé sans préavis.</p>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">f. Aucune garantie</h3>
      <p className="mb-4">L'application Genius Vente est fournie <strong>"en l'état" et "selon disponibilité"</strong>, sans garantie d'aucune sorte. Genius Vente décline toute responsabilité en cas de :</p>
      <ul className="list-disc list-inside mb-4">
        <li>pertes de données,</li>
        <li>interruptions de service,</li>
        <li>erreurs techniques ou dysfonctionnements.</li>
      </ul>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">g. Limitation de responsabilité</h3>
      <p className="mb-4">Dans la limite permise par la loi, Genius Vente ne pourra être tenu responsable de <strong>dommages indirects, spéciaux ou consécutifs</strong>, tels que la perte de chiffre d'affaires, de données ou d'opportunités commerciales. En tout état de cause, la responsabilité maximale de Genius Vente ne saurait excéder <strong>50 USD</strong>.</p>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">h. Restrictions à l'exportation</h3>
      <p className="mb-4">Vous vous engagez à respecter les lois sur le contrôle des exportations applicables, notamment celles des États-Unis et de l'Union européenne. Vous ne devez pas utiliser l'application dans des pays sous embargo ou pour des activités interdites.</p>
      
      <h3 className="text-lg font-semibold mt-4 mb-2">i. Droit applicable</h3>
      <p className="mb-4">Ce contrat est régi par les lois de la République Démocratique du Congo, ou par les lois du pays de résidence de l'utilisateur si celui-ci accède à l'application depuis l'extérieur.</p>
      
      <hr className="my-4" />
      
      <h2 className="text-xl font-semibold mt-6 mb-2">📩 Contact</h2>
      <p className="mb-4">Pour toute question concernant ce CLUF ou l'application Genius Vente, veuillez contacter :</p>
      <div className="bg-gray-50 p-4 rounded-lg">
        <p className="font-semibold mb-2">Genius Vente – Support Légal</p>
        <p className="mb-1">📧 Email : <a href="mailto:support@geniusvente.com" className="text-blue-600 hover:underline">support@geniusvente.com</a></p>
        <p>🌐 Site : <a href="https://www.geniusvente.com" className="text-blue-600 hover:underline">https://www.geniusvente.com</a></p>
      </div>
      
      <hr className="my-4" />
      <p className="text-sm text-gray-500 mt-6">Conditions en vigueur depuis le :<br/>20 juillet 2025</p>
    </div>
  </div>
);

export default Terms; 